
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowLeftGoogle as ObiArrowLeftGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-left-google.js';
 
 
 

 
 export const ObiArrowLeftGoogle = createComponent({
   react: React,
   tagName: 'obi-arrow-left-google',
   elementClass: ObiArrowLeftGoogleElement,
   events: {
     
   }
  });
 
 